module.exports = __webpack_public_path__ + "static/media/invite.0e8fa590.svg";